import { ButtonsProviderService } from '@addins/core/singlecallcard';
import { Injectable } from '@angular/core';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { ProfileService } from '@services/profile/profile.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs';
import { AttachmentsCardButton } from '../../../schema/attachments-card-button';
import { SINGLECALLCARD_ATTACHMENTS } from '../../../schema/constants';
import { AddAttachmentToolsControllerService } from '../../add-attachment-tools-controller/add-attachment-tools-controller.service';
import { AttachmentsCardButtonControllerService } from '../../attachments-card-button-controller/attachments-card-button-controller.service';

@AddinExecute({
  name: 'Attachment tools'
})
@Injectable()
export class AttachmentToolsSetupService extends Execute {
  private attachmentsCardButton: AttachmentsCardButton = null;

  constructor(
    private buttonsProvider: ButtonsProviderService,
    private profileService: ProfileService,
    private profileReader: ProfileReaderService,
    private attachmentsButtonController: AttachmentsCardButtonControllerService,
    private addAttachmentToolsController: AddAttachmentToolsControllerService
  ) {
    super();
  }

  execute() {
    this.profileService.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => this.onProfileReady());
  }

  private onProfileReady() {
    this.attachmentsCardButton = new AttachmentsCardButton();
    this.attachmentsButtonController.setup(this.attachmentsCardButton);
    this.buttonsProvider.add(this.attachmentsCardButton);

    const addAttachmentSources: string[] = this.profileReader.getComponentConfig(SINGLECALLCARD_ATTACHMENTS, 'canAddAttachmentFrom', []);
    if (addAttachmentSources.length) {
      const fromMyCallcardOnly: boolean = this.profileReader.getComponentConfig(SINGLECALLCARD_ATTACHMENTS, 'addFromMyCallcardOnly', true);
      this.addAttachmentToolsController.setup(addAttachmentSources, fromMyCallcardOnly);
    }
  }
}
